import { DermloopRatingEnum } from '@dermloop/static-values';
import {
  IsEnum,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  Max,
  Min,
  ValidateNested,
} from 'class-validator';
import { UserDto } from '../user.dto';
import type { TeledermatologicalAssessmentDto } from './teledermatological-assessment.dtos';

export class CreateTeledermatologicalAssessmentRatingDto {
  @IsNotEmpty()
  @IsString()
  teledermatologicalAssessmentId: string;

  @IsEnum(DermloopRatingEnum)
  rating: DermloopRatingEnum;

  @IsOptional()
  @IsString()
  note?: string;
}

export class TeledermatologicalAssessmentRatingDto {
  @IsString()
  id: string;
  createdByUser?: UserDto;
  updatedByUser?: UserDto;
  deletedByUser?: UserDto;
  created?: Date;
  updated?: Date;
  deleted?: Date;

  @IsEnum(DermloopRatingEnum)
  rating: DermloopRatingEnum;

  @IsOptional()
  @IsString()
  note?: string;

  @IsNotEmpty()
  @IsString()
  teledermatologicalAssessmentId: string;

  @IsOptional()
  @ValidateNested()
  teledermatologicalAssessment?: TeledermatologicalAssessmentDto;
}

export class SearchTeledermatologicalAssessmentRatingsDto {
  @IsOptional()
  @IsNumber()
  @Min(0)
  skip?: number;

  @IsOptional()
  @IsNumber()
  @Min(1)
  @Max(100)
  take?: number;

  @IsOptional()
  @IsEnum(DermloopRatingEnum)
  rating?: DermloopRatingEnum;
}
